import React, { useRef, useEffect, useState, useCallback, useContext } from 'react';
import 'primeicons/primeicons.css';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss'

import '../layout/sass/_responsiveTable.scss'
import { confirmDialog } from 'primereact/confirmdialog';
import api from '../api/api';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Badge } from 'primereact/badge';

import { FormUpload } from './FormUpload';
import { DialogLiquidar } from './DialogLiquidar';

export const TabelaFaturas = ({ liquidadas }) => {
    const history = useHistory();
    const toast = useRef(null);
    const { anoRef, fornecedorNome, user } = useContext(AuthContext);
    const [faturas, setFaturas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const confirmationToast = useRef(null)
    const [sortable, setSortable] = useState('DESC');
    const [first, setFirst] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [sortableCampo, setSortableCampo] = useState('id');
    const [visible, setVisible] = useState(false);
    const [liquidar, setLiquidar] = useState([]);
    const [simular, setSimular] = useState([]);

    const [showListaLiquidar, setShowListaLiquidar] = useState(false);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        sortField: null,
        sortOrder: null,
        filters: {
            'fornecedor.nome': { value: fornecedorNome === "TODOS" ? "" : fornecedorNome, matchMode: 'contains' },
            'anoRef': { value: anoRef === 0 ? "" : anoRef, matchMode: 'contains' },
        }
    });

    const [listFornecedores, setListFornecedores] = useState(null);

    const handleGetFornecedores = useCallback(async () => {

        await api.get("fornecedor/fornecedorAll").then((response) => {

            const fornecedores = response.data.map(item => {

                return {
                    id: item.id,
                    cod: item.codigo,
                    nome: item.nome
                }
            });

            setListFornecedores(fornecedores);
        });

    }, [])

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">{!liquidadas ? "Faturas" : "Faturas Liquidadas"}</h2>
            </div>
            {!liquidadas && (
                <div className="p-my-0 p-grid p-dir-rev p-col">
                    <div className="p-m-2">
                        <Button
                            label="Adicionar"
                            className="p-mb-2 p-button-primary"
                            icon="pi pi-plus"
                            iconPos="left"
                            type="button"

                            onClick={() => history.push('/faturascreate')}

                        />
                    </div>
                    <div className="p-m-2">
                        <Button
                            label="Importar Arquivo"
                            className="p-mb-2 p-button-primary"
                            icon="pi pi-plus"
                            iconPos="left"
                            type="button"

                            onClick={() => setVisible(true)}

                        />
                    </div>
                </div>
            )}
        </div>

    );

    const getFaturas = useCallback(async (event) => {
        setIsLoading(true);
        setFaturas([]);

        const pageEvent = event || {
            first: lazyParams.first,
            rows: lazyParams.rows,
            page: Math.floor(lazyParams.first / lazyParams.rows)
        };

        try {
            const sortOrderStr = lazyParams.sortOrder === 1 ? 'ASC' : 'DESC';
            const sortField = lazyParams.sortField || 'id';

            // Construir objeto de pesquisa com campos corretos
            const pesquisa = {
                instalacaoNumeroInstalacao: lazyParams.filters['instalacaoNumeroInstalacao']?.value || null,
                numero: lazyParams.filters['numero']?.value || null,
                fornecedorNome: lazyParams.filters['fornecedor.nome']?.value || "", // Campo modificado aqui
                liquidado: liquidadas,
                anoRef: lazyParams.filters['anoRef']?.value || null,
            };

            // Verificar se há filtros ativos
            const hasFilters = Object.values(lazyParams.filters).some(
                filter => filter?.value && filter.value !== ''
            );
            // Se há filtros ou está buscando só liquidadas → faz POST (resolvido)
            if (hasFilters || liquidadas) {
                const respElements = await api.post(
                    `faturas/searchFaturas/${sortOrderStr}/${sortField}?page=${pageEvent.page}&size=${pageEvent.rows}`,
                    pesquisa
                );
                setFaturas(respElements.data.content);
                setTotalRecords(respElements.data.totalElements);
            } else {
                const response = await api.get(
                    `faturas?page=${pageEvent.page}&size=${pageEvent.rows}&sort=${sortField},${sortOrderStr}`
                );
                setFaturas(response.data.content);
                setTotalRecords(response.data.totalElements);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter faturas', detail: error.toString() });
        }


        setIsLoading(false)

    }, [lazyParams, sortable, sortableCampo]);


    useEffect(() => {
        const fetchdotacaoOrcamentaria = async () => {
            try {
                await getFaturas();

            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchdotacaoOrcamentaria();

    }, [getFaturas])

    useEffect(() => {

        handleGetFornecedores();

    }, [])



    const idBodyTemplate = (rowData) => {

        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const fornecedorBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Fornecedor</span>
                    <span className="table-data">{rowData.fornecedorNome}</span>
                </p>
            </React.Fragment>
        );
    }

    const dataEmissaoBodyTemplate = (rowData) => {
        
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Data Emissão</span>
                    <span className="table-data">{new Date(rowData.dataEmissao).toLocaleDateString()}</span>
                </p>
            </React.Fragment>
        );
    }

    const dataLiquidacaoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Data Liquidação</span>
                    <span className="table-data">{rowData.dataLiquidacao != undefined ? new Date(rowData.dataLiquidacao).toLocaleDateString() : ""}</span>
                </p>
            </React.Fragment>
        );
    }

    const dataVencimentoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Data Liquidação</span>
                    {rowData.dataVencimento &&
                        <span className="table-data">{new Date(rowData.dataVencimento).toLocaleDateString()}</span>
                    }
                </p>
            </React.Fragment>
        );
    }

    const numeroBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Número</span>
                    <span className="table-data">{rowData.numero}</span>
                </p>
            </React.Fragment>
        );
    }

    const valorTotalBodyTemplate = (rowData) => {
        // let listFaturaItem = rowData.faturaItem;

        // let listItemDetalhe = listFaturaItem.map(item => item.faturaItemDetalhes).flat();

        // let somaImpostoRetido = listItemDetalhe
        //     .filter(item => item.descLancamento.includes("Imposto Retido") || item.descLancamento.includes("IRRF"))
        //     .reduce((total, item) => total + item.valorLancamento, 0);


        // let somaTotal = listItemDetalhe
        //     .filter(item => !item.descLancamento.includes("Imposto Retido") || item.descLancamento.includes("IRRF"))
        //     .reduce((total, item) => total + item.valorLancamento, 0);

        // let totalCalculado = (somaTotal - somaImpostoRetido).toLocaleString('pt-BR', {
        //     style: 'currency',
        //     currency: 'BRL'
        // })

        // let valorTotal = rowData.valorTotal.toLocaleString('pt-BR', {
        //     style: 'currency',
        //     currency: 'BRL'
        // })

        // // Verifica se somaImpostoRetido é igual a valorRetencao
        // let isValorIgual = (totalCalculado) === valorTotal;


        return (
            <React.Fragment>
                <p style={{ textAlign: 'right' }}>
                    <span className="p-column-title">Valor Total dos Serviços</span>{' '}
                    <span className="table-data">
                        {rowData.valorTotal.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </span>
                </p>
            </React.Fragment>
        );

    }

    const valorRetencaoBodyTemplate = (rowData) => {
        // // Acessa a lista de itens de fatura
        // let listFaturaItem = rowData.faturaItem;

        // // Aplana a lista de detalhes
        // let listItemDetalhe = listFaturaItem.map(item => item.faturaItemDetalhes).flat();

        // // Calcula o total do Imposto Retido
        // let somaImpostoRetido = listItemDetalhe
        //     .filter(item => item.descLancamento.includes("Imposto Retido") || item.descLancamento.includes("IRRF"))
        //     .reduce((total, item) => total + item.valorLancamento, 0).toLocaleString('pt-BR', {
        //         style: 'currency',
        //         currency: 'BRL'
        //     });

        // let valorRetencao = rowData.valorRetencao.toLocaleString('pt-BR', {
        //     style: 'currency',
        //     currency: 'BRL'
        // });

        // // Verifica se somaImpostoRetido é igual a valorRetencao
        // let isValorIgual = somaImpostoRetido === valorRetencao;



        return (
            <React.Fragment>
                <p style={{ textAlign: 'right' }}>
                    <span className="p-column-title">Valor Total dos Serviços</span>{' '}
                    <span className="table-data">
                        {rowData.valorRetencao.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </span>
                </p>
            </React.Fragment>
        );
    }

    const actionBodyTemplate = (rowData) => {
        return !liquidadas ? (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handleEditClick(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-mr-2 p-button-danger" loading={isDeleting} onClick={() => handleDeleteClick(rowData)} />
            </div>
        ) : (
            <div className="actions">
                <Button icon="pi pi-eye" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handleSimular(rowData)} />
                <Button icon="pi pi-undo" className="p-button-rounded p-mr-2 p-button-warning" loading={isDeleting} onClick={() => handleExtornarClick(rowData)} />
            </div>
        );
    }

    const statusBodyTemplate = (rowData) => {

        return (
            <div className="status">
                <Badge
                    severity={rowData.dataLiquidacao ? "success" : "warning"}
                    value={rowData.dataLiquidacao ? "Liquidado" : "Não liquidado"}
                    className="custom-badge"
                />
            </div>
        );
    };

    const onSort = (event) => {
        const newSortField = event.sortField;
        const newSortOrder = lazyParams.sortOrder === 1 ? -1 : 1; // Alternar entre 1 (ASC) e -1 (DESC)

        setLazyParams(prevParams => ({
            ...prevParams,
            sortField: newSortField,
            sortOrder: newSortOrder,
            first: 0 // Resetar para a primeira página
        }));
    }

    const handleEditClick = (data) => {


        history.push(`/faturas/edit/${data.id}`);

    }

    const handleSimular = async (row) => {
        const data = {
            'userEmail': user?.email || "",
            'faturas': [row.id],
            'simular': true
        };

        try {
            const selectedFaturas = faturas.filter(f => f.id === row.id && f.fornecedor);
            const response = await api.post(`faturas/liquidar`, data);

            const enrichedResponse = {
                ...response.data,
                liquidacoes: response.data.liquidacoes.map((item) => ({
                    ...item,
                    fornecedorCodigo: selectedFaturas[0]?.fornecedor?.codigo || ""
                }))
            };

            setSimular(true);
            setLiquidar([enrichedResponse]);
            setShowListaLiquidar(true);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao Simular', detail: error.toString() });
        }
    };

    const handleDeleteClick = (data) => {

        data['userEmail'] = user != null ? user.email : ""

        confirmDialog({
            message: `Você tem certeza que quer remover a fatura?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {

                    const response = await api.delete(`faturas/${data.id}`);

                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `a fatura foi removida com sucesso` });
                    getFaturas()
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover a fatura', detail: error.toString() });
                }

                setIsDeleting(false);
            },
            reject: () => { return }
        });
    }

    const handleExtornarClick = (data) => {

        data['userEmail'] = user != null ? user.email : ""

        confirmDialog({
            message: `Confirma extorno das liquidações da fatura?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {

                    const response = await api.post(`faturas/extornarLiquidacao/${data.id}`);

                    toast.current.show({ life: 5000, severity: 'success', summary: 'Extorno concluído!', detail: `As liquidações foram extornadas com sucesso` });
                    getFaturas()
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao extornar a fatura', detail: error.toString() });
                }

                setIsDeleting(false);
            },
            reject: () => { return }
        });
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

                <DialogLiquidar
                    visible={showListaLiquidar}
                    setVisible={setShowListaLiquidar}
                    liquidar={liquidar}
                    simular={simular}
                    setLazyParams={setLazyParams}
                />

                <Toast ref={toast} position="bottom-right" />

                <Toast ref={confirmationToast} position="bottom-center" />

                <FormUpload visible={visible} setVisible={setVisible} listFornecedores={listFornecedores} setLazyParams={setLazyParams} Titulo="Selecione a Fatura" uploadTipo="1" />

                <div className="card p-col-12 datatable-responsive-demo">

                    <div className="p-fluid">
                        <DataTable
                            totalRecords={totalRecords}
                            lazy="true"
                            first={first}
                            onPage={getFaturas}
                            header={header}
                            value={faturas}
                            filterDisplay="row"
                            className="p-datatable-responsive-demo"
                            emptyMessage="Nenhuma fatura encontrada"
                            loading={isLoading}
                            dataKey="id"
                            paginator
                            rows={20}
                            currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} faturas`}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            // rowsPerPageOptions={[50, 100]}
                            onSort={onSort}
                            filters={lazyParams.filters}
                            onFilter={(e) => {
                                setLazyParams(prev => ({
                                    ...prev,
                                    filters: e.filters,
                                    first: 0
                                }));
                            }}
                        >

                            <Column
                                field="id"
                                header="Código"
                                sortable
                                body={idBodyTemplate}
                                lazyParams

                            />

                            <Column
                                field="fornecedor.nome"
                                header="Fornecedor"
                                sortable
                                body={fornecedorBodyTemplate}
                                filter={fornecedorNome === "TODOS"}
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por Fornecedor"
                                sortField="fornecedor.nome"
                                filterField="fornecedor.nome"
                            />

                            <Column
                                field="dataEmissao"
                                header="Data de Emissão ..."
                                sortable
                                body={dataEmissaoBodyTemplate}
                                lazyParams
                            />

                            <Column
                                field="dataLiquidacao"
                                header="Data de Liquidação"
                                sortable
                                body={dataLiquidacaoBodyTemplate}
                                lazyParams

                            />

                            <Column
                                field="dataVencimento"
                                header="Data de Vencimento"
                                sortable
                                body={dataVencimentoBodyTemplate}
                                lazyParams

                            />

                            <Column
                                field="numero"
                                header="Número"
                                sortable
                                body={numeroBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por número"
                            />

                            <Column
                                field="valorTotal"
                                header="Valor Total dos Serviços"
                                sortable
                                body={valorTotalBodyTemplate}

                            />


                            <Column
                                field="valorRetencao"
                                header="Valor Retenção"
                                sortable
                                body={valorRetencaoBodyTemplate}

                            />

                            {(liquidadas === false || liquidadas === undefined) && (
                                <Column
                                    header="Status"
                                    sortable
                                    sortField="dataLiquidacao" // Adicione esta linha
                                    body={statusBodyTemplate}
                                />
                            )}


                            <Column
                                header="Ações"
                                body={actionBodyTemplate}

                            />

                        </DataTable>

                    </div>
                </div>
            </div>

        </>
    );
}
